<script>
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { NextButton },
  emits: ['take-over'],
};
</script>

<template>
  <div class="flex flex-1 items-center justify-center p-6">
    <div
      class="w-full max-w-xl rounded-2xl border border-n-weak bg-n-solid-2 p-8 shadow-sm"
    >
      <div class="flex flex-col gap-3">
        <h2 class="text-heading-2 text-n-slate-12">
          {{ $t('GENERAL_SETTINGS.SINGLE_TAB_GUARD.TITLE') }}
        </h2>
        <p class="mb-0 text-body-para text-n-slate-11">
          {{ $t('GENERAL_SETTINGS.SINGLE_TAB_GUARD.DESCRIPTION') }}
        </p>
      </div>
      <div class="mt-6 flex gap-3">
        <NextButton
          blue
          :label="$t('GENERAL_SETTINGS.SINGLE_TAB_GUARD.ACTION')"
          @click="$emit('take-over')"
        />
      </div>
    </div>
  </div>
</template>
